var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiplePerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12868_66526)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12868_66526",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000974655H24V23.999H0V-0.000974655Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12868_66526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 16.0313C4.78125 16.0313 5.625 16.875 5.625 17.9063V18.8438C5.625 19.875 4.78125 20.7188 3.75 20.7188C2.71875 20.7188 1.875 19.875 1.875 18.8438V17.9063C1.875 16.875 2.71875 16.0313 3.75 16.0313Z",
    stroke: "#0A5EF3",
    strokeWidth: 0.9375,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1758 20.1086C6.27141 20.6416 7.03125 21.7672 7.03125 23.0616V23.5303H0.46875V23.0616C0.46875 21.7696 1.22573 20.6458 2.31802 20.1116",
    stroke: "#0A5EF3",
    strokeWidth: 0.9375,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 16.0313C21.2812 16.0313 22.125 16.875 22.125 17.9063V18.8438C22.125 19.875 21.2812 20.7188 20.25 20.7188C19.2187 20.7188 18.375 19.875 18.375 18.8438V17.9063C18.375 16.875 19.2187 16.0313 20.25 16.0313Z",
    stroke: "#0A5EF3",
    strokeWidth: 0.9375,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6637 20.1028C22.7658 20.6334 23.5312 21.7624 23.5312 23.0616V23.5303H16.9688V23.0616C16.9688 21.7621 17.7345 20.6329 18.8369 20.1025",
    stroke: "#0A5EF3",
    strokeWidth: 0.9375,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.0313C13.0312 16.0313 13.875 16.875 13.875 17.9063V18.8438C13.875 19.875 13.0312 20.7188 12 20.7188C10.9687 20.7188 10.125 19.875 10.125 18.8438V17.9063C10.125 16.875 10.9687 16.0313 12 16.0313Z",
    stroke: "#0A5EF3",
    strokeWidth: 0.9375,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4281 20.1098C14.5225 20.6432 15.2812 21.7681 15.2812 23.0616V23.5303H8.71875V23.0616C8.71875 21.7679 9.47761 20.643 10.572 20.1097",
    stroke: "#0A5EF3",
    strokeWidth: 0.9375,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.28027C13.0312 3.28027 13.875 4.12402 13.875 5.15527V6.09277C13.875 7.12402 13.0312 7.96777 12 7.96777C10.9687 7.96777 10.125 7.12402 10.125 6.09277V5.15527C10.125 4.12402 10.9687 3.28027 12 3.28027Z",
    stroke: "#0A5EF3",
    strokeWidth: 0.9375,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78906 9.64258C9.00089 8.63134 9.68213 7.78741 10.592 7.35109M13.414 7.35292C14.3144 7.78609 14.9902 8.61855 15.2078 9.61703",
    stroke: "#0A5EF3",
    strokeWidth: 0.9375,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0151 0.863915C10.6261 0.608868 11.2965 0.467774 12 0.467774C14.8477 0.467774 17.1562 2.77627 17.1562 5.62402C17.1562 8.47173 14.8477 10.7803 12 10.7803C9.15225 10.7803 6.84375 8.47173 6.84375 5.62402C6.84375 4.99941 6.95484 4.40073 7.15833 3.84671",
    stroke: "#0A5EF3",
    strokeWidth: 0.9375,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 15.9336V14.3426C20.25 13.827 19.8282 13.4051 19.3125 13.4051H4.68745C4.17187 13.4051 3.75 13.827 3.75 14.3426V15.9336",
    stroke: "#0A5EF3",
    strokeWidth: 0.9375,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.8694V15.9424",
    stroke: "#0A5EF3",
    strokeWidth: 0.9375,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27734 2.05762H8.27739",
    stroke: "#0A5EF3",
    strokeWidth: 0.9375,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12868_66526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplePerson);
export default __webpack_public_path__ + "static/media/multiple_person.cb0c3a53a74ac2b606f8b4687edc1c07.svg";
export { ForwardRef as ReactComponent };